/** Shared homepage section colors and spacing — keep new sections aligned. */
export const SECTION_TINT = "#faf6f9";
export const SECTION_NAVY = "#202338";
export const SECTION_WHITE = "#ffffff";
export const SECTION_PANEL_NAVY = "#2a2d45";

export const TEXT_HEADING = "#202338";
export const TEXT_BODY = "#4a5568";
export const TEXT_MUTED = "#8690a0";

export const SECTION_PADDING_Y = {
  mobile: "64px 0 72px",
  desktop: "80px 0 96px",
};

export const SECTION_PADDING_Y_COMPACT = {
  mobile: "48px 0 64px",
  desktop: "64px 0 80px",
};
